import { type ComponentProps } from "react";
import { View } from "@-/com.npmjs.react-native";
import { cn } from "@-/com.npmjs.cn";
import { GraphemeFontGlyph } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.grapheme.glyph.font";
import type { WordGlyph } from "#word-glyph";

type WordFontGlyphProps = Omit<ComponentProps<typeof View>, "children"> & {
  glyphClassName?: ComponentProps<typeof GraphemeFontGlyph>["className"];
  glyphList: WordGlyph;
} & Omit<ComponentProps<typeof GraphemeFontGlyph>, "children" | "glyph">;

export function WordFontGlyph({
  className,
  glyphClassName,
  glyphList,
  ...glyphProps
}: WordFontGlyphProps) {
  return (
    <View className={cn("flex-row items-baseline", className)}>
      {glyphList.map((glyph, index) => (
        <GraphemeFontGlyph
          className={glyphClassName}
          glyph={glyph}
          key={`${glyph.original}-${index}`}
          {...glyphProps}
        />
      ))}
    </View>
  );
}
